export default __webpack_public_path__ + "static/media/services-bg-rev.c1a92933.png";